export function labelFromOptions(options, value) {
  if (!value) return '—';
  const found = (options || []).find((o) => o.value === value);
  return found ? found.label : value;
}

export function formatAuditDisplay(value) {
  if (!value || !String(value).trim()) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
  } catch {
    return value;
  }
}

export function buildFailureReasons(checks) {
  return checks.filter((c) => !c.pass).map((c) => c.reason);
}

export function runScenarioTest(form, evaluate, compareChecks) {
  const evaluation = evaluate(form);
  const failReasons = buildFailureReasons(compareChecks(form, evaluation));
  const passed = failReasons.length === 0;
  return {
    testStatus: passed ? 'Pass' : 'Fail',
    expectedAndActualMatch: passed ? 'Yes' : 'No',
    failReasons,
    failureReason: failReasons.join(' '),
    messageShown: evaluation.messageShown || '—',
    nextAction: evaluation.nextAction || '—',
    displayResults: evaluation.displayResults || [],
    ...evaluation.resultFields,
    actual: evaluation.actual,
  };
}

export function getLatestSavedRule(ruleFromState, allRules, ruleId, { getEditRuleSource, normalize }) {
  if (ruleFromState?.id) {
    const fromList = (allRules || []).find((r) => r.id === ruleFromState.id);
    const base = fromList || ruleFromState;
    return getEditRuleSource(base, { preferDraft: true }) || normalize(base);
  }
  if (ruleId) {
    const found = (allRules || []).find((r) => r.id === ruleId);
    if (found) return getEditRuleSource(found, { preferDraft: true }) || normalize(found);
  }
  return null;
}
